module.exports = __webpack_public_path__ + "static/media/tsunami_shin_guide.drawio.1900dc92.svg";